<template>
    <div class="customer-detail-order">
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="订单状态选择">
                <el-select v-model="formInline.statusClass" placeholder="订单状态" @change="handleSelectOption">
                    <el-option v-for="item in orderStateList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-table border :data="orderList" :size="GCONFIG.styleTableSize">
            <el-table-column label="序号" width="50" type="index"></el-table-column>
            <el-table-column type="expand" label="展开订单详情" width="70">
                <template slot-scope="scope">
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">收件人:</el-col>
                        <el-col class="expand-content">
                            {{scope.row.consigneeName}}
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">收件电话:</el-col>
                        <el-col class="expand-content">
                            {{scope.row.consigneePhone}}
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">送货地址:</el-col>
                        <el-col class="expand-content">
                            {{scope.row.consigneeProvincename}} {{scope.row.consigneeCityname}} {{scope.row.consigneeAreaname}} {{scope.row.consigneeAddr}}
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">配送时间:</el-col>
                        <el-col class="expand-content">
                            {{scope.row.deliverDate}}
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">订单合计:</el-col>
                        <el-col class="expand-content">
                            {{setPrice(scope.row.totalAmount)}}元
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">运费:</el-col>
                        <el-col class="expand-content">
                            {{setPrice(scope.row.freight)}}元
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">余额支付:</el-col>
                        <el-col class="expand-content">
                            {{setPrice(scope.row.balanceAmount)}}元
                        </el-col>
                    </el-row>
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">优惠券支付:</el-col>
                        <el-col class="expand-content">
                            {{setPrice(scope.row.couponAmount)}}元
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row type="flex" class="expand-flex">
                        <el-col class="expand-title">订单商品:</el-col>
                        <el-col class="expand-content">
                            <div class="expand-flex-con">
                                <div class="expand-content" v-for="item in scope.row.orderProductVos">
                                    <el-tag effect="plain" type="danger">{{item.itemName}}【{{item.quantity}}】</el-tag>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column label="主订单号" width="200" prop="orderMainNo"></el-table-column>
            <el-table-column prop="consigneeName" label="收件人" width="90"></el-table-column>
            <el-table-column prop="consigneePhone" label="电话" width="100"></el-table-column>
            <el-table-column prop="createTime" label="下单时间" width="150"></el-table-column>
            <el-table-column label="订单来源">
                <template slot-scope="scope">
                    <el-tag size="mini" v-if="scope.row.deliverCount>1" type="danger" effect="plain">{{orderStatusClass[scope.row.deliverCount]}}</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==1" effect="plain">购物车</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==6" type="success" effect="plain">限时特惠</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==7" effect="plain">满减</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==14" effect="plain">团购</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==16" effect="plain">套装直接买</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==19" type="success" effect="plain">非实物限惠</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==21" type="success" effect="plain">五块钱活动</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==22" type="success" effect="plain">五块钱活动</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==23" type="success" effect="plain">众筹</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==24" type="success" effect="plain">企业专属活动</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==25" type="success" effect="plain">储值卡订单</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==26" type="success" effect="plain">奶卡实物订单</el-tag>
                    <el-tag size="mini" v-if="scope.row.orderSource==27" type="success" effect="plain">奶卡非实物订单</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="statusName" label="订单状态" width="110">
                <template slot-scope="scope">
                    <el-tag size="mini" :type="orderState[scope.row.status]">{{scope.row.statusName}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="198">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="toOrderDetail(scope.row.orderMainNo)">订单详情</el-button>
                    <el-button v-show="showSetPayed" v-if="scope.row.statusClass==1||scope.row.statusClass==6" type="danger" size="mini" @click="changeState(scope.row.orderMainNo)">修改为已支付</el-button>
                </template>
            </el-table-column>

        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.pageCount"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalRecord">
            </el-pagination>
        </div>
        <el-drawer
                title="嵌入ERP老页面"
                :visible.sync="drawerShow"
                direction="rtl"
                :before-close="handleClose"
                size="70%">
            <iframe :src="toUrl" width="100%" height="100%"></iframe>
        </el-drawer>
    </div>
</template>
<script>
    import {getCustomerOrderListInfo,changeCustomerOrderState} from '@/api/api'
    export default{
        data(){
            return {
                formInline:{
                    customerId:this.$route.params.id,
                    pageCount:1,
                    statusClass:0,
                    pageSize:10,
                },
                status:'',
                orderList:[],
                customer:{},
                showH:false,
                showSetPayed:false,//不显示设置订单已支付
                orderStateList:[{
                    value:0,
                    label:'全部'
                },{
                    value:1,
                    label:'待支付'
                },{
                    value:2,
                    label:'待发货'
                },{
                    value:3,
                    label:'待收货'
                },{
                    value:4,
                    label:'待评价'
                },{
                    value:5,
                    label:'已退款'
                },{
                    value:6,
                    label:'已取消'
                },{
                    value:7,
                    label:'交易完成'
                }],
                orderState:{
                    '16':'success',
                    '2':'',
                    '3':'warning',
                    '0':'info',
                    '27':'danger'
                },
                orderStatusClass:{
                    '2':'拆单',
                    '4':'包月',
                    '12':'包季',
                    '52':'包年',
                },
                totalRecord:0,
                drawerShow:false,
                toUrl:''
            }
        },
        mounted(){
            this.getUserAddressList()
        },
        methods:{
            getUserAddressList(){
                getCustomerOrderListInfo(this.formInline).then(res=>{
                    console.log(res)
                    this.orderList = res.data.value.orderList?res.data.value.orderList.list:[]
                    this.customer = res.data.value.customer
                    this.totalRecord = res.data.value.orderList?res.data.value.orderList.total:0
                })
            },
            addressType(type){
                type=type||0
                return this.addressTypeArr[type]
            },
            handleSelectOption(val){
                console.log(val)
                this.formInline.statusClass = val;
                this.formInline.pageCount = 1;
                this.getUserAddressList();
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getUserAddressList();
            },
            handleCurrentChange(val) {
                this.formInline.pageCount = val;
                this.getUserAddressList();
            },
            setPrice(price){
                return parseFloat(price).toFixed(2)
            },
            toOrderDetail(orderNo){
                this.drawerShow = true;
                if(window.location.href.indexOf('check')!= -1){
                    this.toUrl = `http://erptest.lechun.cc/admin_sold_show.html?SOLD_ID=${orderNo}`+'&userName='+  window.localStorage.getItem('loginUser');
                }else {
                    //生产环境
//                    this.toUrl = `//erpnew.lechun.cc/admin_sold_show.html?SOLD_ID=${orderNo}`+'&userName='+  window.localStorage.getItem('loginUser');
                    window.location.href=`//erpnew.lechun.cc/admin_sold_show.html?SOLD_ID=${orderNo}`+'&userName='+  window.localStorage.getItem('loginUser');
                }
            },
            handleClose(done){
                done()
                this.getUserAddressList()
            },
            changeState(orderNo){
                this.$confirm('此操作将修改订单状态为「已支付」, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    changeCustomerOrderState({mainOrderNo:orderNo}).then(res=>{
                        if(res.data.status==200){
                            this.$notify({
                                title: '成功',
                                message: '修改成功',
                                type: 'success'
                            });
                            this.getUserAddressList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消修改'
                    });
                });

            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .customer-detail-order{
        .customer-nick{
            margin: 0;
        }
        .el-table th{
            background: #f1f1f1;
            color: #222222;
        }
        .el-table__expanded-cell{
            background: #f5f5f5;
            text-align: left;
            padding: 7px 50px;
        }
        .el-table__expanded-cell:hover{
            background: #f5f5f5 !important;
        }
        .expand-title{
            width: 70px;
            color: #444548;
            line-height: 30px;
            text-align: right;
            margin-right: 10px;
            font-weight: 600;
        }
        .expand-flex,.expand-flex-con{
            justify-content: flex-start;
            align-items: center;
            align-content: center;
        }
        .expand-flex-con{
            display: flex;
            flex-wrap: wrap;
            .expand-content{
                margin: 5px 10px 5px 0;
            }
        }
        .el-table__expand-icon>.el-icon{
            font-size: 16px;
            font-weight: bolder;
        }
        .el-divider--horizontal{
            margin: 10px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/userSystem/customerOrder.vue